/**
 * Echo stub — replaces Laravel Echo + Pusher.
 * Realtime is handled via SSE / EventSource in Next.js.
 */

const echo = {
    channel: (name: string) => ({
        listen: (event: string, callback: (data: unknown) => void) => echo.channel(name),
        stopListening: (event: string) => echo.channel(name),
    }),
    private: (name: string) => ({
        listen: (event: string, callback: (data: unknown) => void) => echo.private(name),
        stopListening: (event: string) => echo.private(name),
    }),
    leave: (name: string) => {},
    disconnect: () => {},
};

export default echo;
